import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ContentDownloadItem } from '@ilteducation/content-ref-data-types';
import {
  downloadExternalContent,
  getExternalContentDownloadUrl,
  listExternalContentDownloads,
} from '@/data-provider/refDataProvider';
import eventBus from '@/foundations/services/eventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const downloads = ref<ContentDownloadItem[]>();

const loadDownloads = async () => {
  downloads.value = await listExternalContentDownloads();
};
loadDownloads();

const headers = [
  {
    sortable: true,
    text: 'isbn',
    value: 'isbn',
  },
  {
    sortable: true,
    text: 'Title',
    value: 'title',
  },
  {
    sortable: true,
    text: 'Type',
    value: 'type',
  },
  {
    sortable: true,
    text: 'Download',
    value: 'isCached',
  },
];

const getIcon = (item: ContentDownloadItem): string => {
  switch (item.type) {
    case 'epub':
      return 'mdi-book-open-variant';
    case 'pdf':
      return 'mdi-file-pdf-box';
    case 'mp3':
      return 'mdi-music';
    default:
      return 'mdi-book-open-variant';
  }
};

const downloadToCache = async (item: ContentDownloadItem): Promise<void> => {
  await downloadExternalContent(item.isbn, item.type, undefined, false);
  eventBus.$emit('snackbar.open', `Download of ${item.type} to cache for isbn: ${item.isbn} started`);
};

const download = async (item: ContentDownloadItem): Promise<void> => {
  const url = await getExternalContentDownloadUrl(item);
  if (url) {
    window.open(url, '_self');
  } else {
    eventBus.$emit('snackbar.open', `Failed to get download url`);
  }
};


return { __sfc: true,downloads, loadDownloads, headers, getIcon, downloadToCache, download }
}

})